import React, {lazy, Suspense} from "react";
import {Route, Switch} from "react-router-dom";
import Loading from 'components/shared/Loading';
import {APP_PREFIX_PATH} from 'configs/AppConfig'

import IBaseProps from "model/interface/IBaseProps";
import IRoute from "model/interface/dataStorage/IRoute";
import {connect, RootStateOrAny} from "react-redux";
import boolean from "../../../utils/Filter/input/Boolean";
import Overview from "../ui/holiday/Overview";

const RoutesRouter = lazy(() => import(`components/app/router/RoutesRouter`))

interface IState {
}

interface IProps extends IBaseProps {
    routesIndex: { [x:string]: IRoute }
}

// --- 1. STABLE LAZY DEFINITIONS (OUTSIDE THE CLASS) ---
// By defining these here, they are initialized once.
const FileManager = lazy(() => import(`components/app/file-manager`));
const Security = lazy(() => import(`components/app/security`));
const GeneratedDocs = lazy(() => import(`components/app/generated-document`));
const Import = lazy(() => import(`components/app/import`));
const Symfony = lazy(() => import(`components/app/symfony-console/Overview`));
const Company = lazy(() => import(`components/app/company`));
const Configuration = lazy(() => import(`components/app/configuration`));
const Settings = lazy(() => import(`components/app/settings/Overview`));
const Calendar = lazy(() => import(`components/app/personal-calendar/PersonalCalendar`));
const Dictionary = lazy(() => import(`components/app/settings/dictionary/Overview`));
const Error403 = lazy(() => import(`components/app/error/Error403`));
const Error404 = lazy(() => import(`components/app/error/Error404`));
const Home = lazy(() => import(`components/app/home/Home`));
export class AppRouter extends React.Component<IProps, IState> {

    state = {
    }

    render() {
        const routesIndex = this.props.routesIndex
        return (
            <Suspense fallback={<Loading cover="content"/>}>
                <Switch>
                    <Route path={`${APP_PREFIX_PATH}/file-manager`} component={FileManager} />
                    <Route path={`${APP_PREFIX_PATH}/security`} component={Security} />
                    <Route path={`${APP_PREFIX_PATH}/generated-documents`} component={GeneratedDocs} />
                    <Route path={`${APP_PREFIX_PATH}/import`} component={Import} />
                    <Route path={`${APP_PREFIX_PATH}/symfony-console`} component={Symfony} />
                    <Route path={`${APP_PREFIX_PATH}/company`} component={Company} />
                    <Route path={`${APP_PREFIX_PATH}/configuration`} component={Configuration} />
                    <Route path={`${APP_PREFIX_PATH}/settings`} component={Settings} />
                    <Route path={`${APP_PREFIX_PATH}/personal-calendar`} component={Calendar} />
                    <Route path={`${APP_PREFIX_PATH}/dictionary-settings`} component={Dictionary} />
                    <Route path={`${APP_PREFIX_PATH}/holidays-settings`} component={Overview} />

                    <Route path={`${APP_PREFIX_PATH}/no-access`} component={Error403} />

                    {Object.entries(routesIndex).map(([path, route]) => {
                        return (
                            <Route exact={true} key={route.id} path={path} render={props => <RoutesRouter {...props} path={this.props.history.location.pathname}/>}/>
                        )
                    })}

                    <Route path={`${APP_PREFIX_PATH}/`} exact component={Home} />
                    <Route path={`${APP_PREFIX_PATH}/`} component={Error404} />
                    {/*<Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/dashboards`}/>*/}
                </Switch>
            </Suspense>
        )
    }
}

const mapStateToProps = ({ setup }: RootStateOrAny ) => {
    const  { routesIndex } = setup
    return { routesIndex }
}

export default connect(mapStateToProps)(React.memo(AppRouter));
